import React, { Component } from 'react';
import { truncate } from 'lodash';
import { Icon } from 'ui';

class SuccessNotification extends Component {
  render() {
    const { content } = this.props;
    const truncatedTitle = truncate(content.title, { length: 50 });

    return (
      <div className="NotificationContainer NotificationContainer--secondary NotificationContainer--success SaveContentModal-success bdrs-2">
        <div className="NotificationContainer-left mt-0">
          <span className="NotificationContainer-icon">
            <Icon name="info" />
          </span>
          <span className="NotificationContainer-message">
            {content.message}
            <b>{truncatedTitle}</b>
          </span>
        </div>
        <div className="NotificationContainer-right mt-0">
          <button
            type="button"
            className="NotificationContainer-dismissButton"
            onClick={this.props.dismissCallback}
          >
            Dismiss
          </button>
        </div>
      </div>
    );
  }
}

export default SuccessNotification;
